/* Verve Jade — scroll reveal (仅 Fade-up/Image Reveal, 600-1200ms) */
(function () {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
  function run() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
})();
